<template>
  <div class="row">
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <b-row v-if="!extData.id">
              <b-col cols="5">
                <b-row>
                  <b-col cols="12">
                    <b-form-group
                      label-cols="3"
                      label-cols-lg="3"
                      label="1.Hệ đào tạo:"
                      label-for="trainingSystemSelected"
                    >
                      <v-select
                        v-model="trainingSystemSelected"
                        :options="trainingSystemsOptions"
                        :reduce="option => option.value"
                        :disabled="!!extData.id"
                        :clearable="false"
                        placeholder="1.Chọn hệ đào tạo"
                        @input="onChangeTrainingSystem"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group
                      label-cols="3"
                      label-cols-lg="3"
                      label="2.Khóa - Học kỳ:"
                      label-for="coursesSemestersSelected"
                    >
                      <v-select
                        v-model="coursesSemestersSelected"
                        :options="coursesSemestersOptions"
                        :reduce="option => option.value"
                        :disabled="!!extData.id"
                        :clearable="false"
                        placeholder="2.Chọn khóa - học kỳ"
                        @input="onChangeCoursesSemester"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="7">
                <b-row>
                  <b-col cols="12">
                    <b-form-group
                      label-cols="3"
                      label-cols-lg="2"
                      label="3.Môn học:"
                      label-for="subjectsSelected"
                    >
                      <v-select
                        v-model="subjectsSelected"
                        :options="subjectsOptions"
                        :reduce="option => option.value"
                        :disabled="!!extData.id"
                        :clearable="false"
                        placeholder="3.Chọn môn học:"
                        @input="onChangeSubjects"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group
                      label-cols="3"
                      label-cols-lg="2"
                      label="4.Phòng thi:"
                      label-for="examinationRoomSubjectsSelected"
                    >
                      <v-select
                        v-model="examinationRoomSubjectsSelected"
                        :options="examinationRoomSubjectsOptions"
                        :reduce="option => option.value"
                        :disabled="!!extData.id"
                        :clearable="false"
                        placeholder="4.Chọn phòng thi"
                        @input="onChangeExaminationRoomSubjects"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <div class="text-right">
                  <b-button
                    v-show="filter.examination_room_id > 0 && !isCreateHeader && headerCodeCreatable && studentExaminationRooms.length > 0"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    style="margin-right: 5px"
                    @click="onCreateHeaderCode"
                  >
                    <span class="text-nowrap text-right"><feather-icon icon="PlusIcon" /> Tạo phách</span>
                  </b-button>
                  <b-button
                    v-show="filter.examination_room_id > 0 && isCreateHeader && canRemixHeaderCode && studentExaminationRooms.length > 0"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    style="margin-right: 5px"
                    @click="onCreateHeaderCodeAgain"
                  >
                    <span class="text-nowrap text-right"><feather-icon icon="RefreshCwIcon" /> Tạo lại phách</span>
                  </b-button>
                  <b-button
                    v-show="filter.examination_room_id > 0"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="info"
                    style="margin-right: 5px"
                    @click="onSelectStudentExaminationRoom"
                  >
                    <span class="text-nowrap text-right"><feather-icon icon="ListIcon" /> Xem danh sách</span>
                  </b-button>
                  <b-button
                    v-show="filter.examination_room_id > 0 && reportExaminationStudentTnh"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    style="margin-right: 5px"
                    @click="exportExaminationStudentTnh"
                  >
                    <span class="text-nowrap text-right"><feather-icon icon="DownloadIcon" /> Tải danh sách sinh viên</span>
                  </b-button>
                  <b-button
                    v-show="selectedRowTable.length > 0 && (changeExaminationRoomUpdatable || supervisorExaminationRoomUpdatable)"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    style="margin-right: 5px"
                    @click="onChangeExaminationRom"
                  >
                    <span class="text-nowrap text-right"><feather-icon icon="SkipForwardIcon" />Chuyển phòng thi</span>
                  </b-button>
                  <b-dropdown
                    v-show="filter.examination_room_id > 0 && changeExaminationRoomPrintable && studentExaminationRooms.length>0"
                    style="margin-right: 5px;"
                    right
                    variant="success"
                    icon="InfoIcon"
                    text="Xuất pdf"
                  >
                    <b-dropdown-item
                      variant="primary"
                      class="btn-icon"
                      size="sm"
                      @click="downloadPdf"
                    >
                      Danh sách phách sinh viên
                    </b-dropdown-item>
                    <b-dropdown-item
                      variant="primary"
                      class="btn-icon"
                      size="sm"
                      @click="downloadPdf_DiemPhach"
                    >
                      Danh sách phách vào điểm sinh viên
                    </b-dropdown-item>
                  </b-dropdown>
                  <b-dropdown
                    v-show="filter.examination_room_id > 0 && changeExaminationRoomPrintable && studentExaminationRooms.length>0"
                    right
                    variant="success"
                    icon="InfoIcon"
                    text="Xuất excel"
                  >
                    <b-dropdown-item
                      variant="primary"
                      class="btn-icon"
                      size="sm"
                      @click="exportExcel"
                    >
                      Danh sách phách sinh viên
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="12">
                <vue-good-table
                  mode="remote"
                  class="my-table"
                  style-class="my-table vgt-table striped bordered"
                  :columns="columns"
                  :rows="studentExaminationRooms"
                  :pagination-options="paginationOptions"
                  :select-options="{
                    enabled: true,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                    disableSelectInfo: true, // disable the select info panel on top
                    selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                  }"
                  @on-selected-rows-change="selectionChanged($event)"
                >
                  <div
                    slot="emptystate"
                    style="text-align: center; font-weight: bold"
                  >
                    Không có bản ghi nào !
                  </div>
                  <template
                    slot="table-row"
                    slot-scope="props"
                  >
                    <span v-if="props.column.field === 'stt'">
                      {{ props.row.originalIndex + 1 }}
                    </span>
                    <span v-else-if="props.column.field === 'header_code'">
                      {{ (headerCodeCreatable || canRemixHeaderCode) ? props.row.header_code : '---' }}
                    </span>
                    <span v-else-if="props.column.field === 'action'">
                      <b-button-group>
                        <b-button
                          v-show="props.row.status >= 0"
                          v-b-modal.revenueSaveModal
                          variant="warning"
                          class="btn-icon"
                          size="sm"
                          title="Xử lý vi phạm"
                          @click="onDeducted(props.row)"
                        >
                          <feather-icon icon="AlertTriangleIcon" />
                        </b-button>
                        <b-dropdown
                          right
                          variant="danger"
                          no-caret
                          size="sm"
                        >
                          <template #button-content>
                            <feather-icon
                              icon="MoreHorizontalIcon"
                              size="16"
                              class="align-middle text-body"
                            />
                          </template>
                          <b-dropdown-item
                            v-show="(props.row.status >= 0 & !props.row.header_code)"
                            v-b-modal.revenueSaveModal
                            variant="warning"
                            class="btn-icon"
                            size="sm"
                            title="Xử lý vắng thi"
                            @click="onMarkAbsent(props.row)"
                          >Xử lý vắng thi
                          </b-dropdown-item>
                          <b-dropdown-item
                            v-show="(props.row.status >= 0 & !props.row.header_code)"
                            variant="danger"
                            class="btn-icon"
                            size="sm"
                            title="Hủy bài thi"
                            @click="onBan(props.row)"
                          >
                            Hủy bài thi
                          </b-dropdown-item>
                        </b-dropdown>
                      </b-button-group>
                    </span>
                    <!-- Column: Common -->
                    <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-container>
    <b-modal
      id="examinationRoomModal"
      ref="examinationRoomModal"
      size="lg"
      title="Danh sách phòng thi"
    >
      <v-select
        v-model="room_id_change"
        :options="roomOptions"
        :reduce="option => option.value"
      />
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            @click="onSave()"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="$bvModal.hide('examinationRoomModal')"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Hủy
            </span>
          </b-button>
        </div>
      </template>
    </b-modal>
    <validation-observer
      ref="deductedFormRef"
      #default="{invalid}"
    >
      <b-modal
        id="deductedModal"
        ref="deductedModal"
        size="lg"
        title="Xử lý trường hợp vi phạm"
      >
        <b-row>
          <b-col cols="12">
            <b-form-group
              label-cols="3"
              label-cols-lg="3"
              label-for="absentType"
            >
              <template v-slot:label>
                Mức xử lý <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Mức xử lý"
                rules="required"
              >
                <v-select
                  v-model="deductedValue"
                  :options="deductLevels"
                  :reduce="option => option.value"
                  @input="onchangeDeductLevel"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group
              label-cols="3"
              label-cols-lg="3"
            >
              <template v-slot:label>
                Lý do vi phạm <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Lý do vi phạm"
                rules="required"
              >
                <b-form-input
                  v-model="deductedReason"
                  type="text"
                  :state="getElementState(errors)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <template #modal-footer>
          <div class="w-100 d-flex justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-1"
              :disabled="invalid"
              @click="onSaveDeducted()"
            >
              <span class="text-right">
                <feather-icon icon="CheckIcon" /> Lưu
              </span>
            </b-button>

            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-secondary"
              @click="$bvModal.hide('deductedModal')"
            >
              <span class="text-right">
                <feather-icon icon="XIcon" /> Hủy
              </span>
            </b-button>
          </div>
        </template>
      </b-modal>
    </validation-observer>

    <validation-observer
      ref="creditClassSaveFormRef"
      #default="{invalid}"
    >
      <b-modal
        id="absentModal"
        ref="absentModal"
        size="lg"
        title="Xử lý trường hợp vắng thi"
      >
        <b-row>
          <b-col cols="12">
            <b-form-group
              label-cols="3"
              label-cols-lg="3"
              label-for="absentType"
            >
              <template v-slot:label>
                Hình thức xử lý <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Hình thức xử lý"
                rules="required"
              >
                <v-select
                  v-model="absentForm.absentType"
                  :options="absentTypes"
                  :reduce="option => option.value"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group
              label-cols="3"
              label-cols-lg="3"
              label="Lý do vắng:"
            >
              <b-form-input
                v-model="absentForm.note"
                type="text"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <template #modal-footer>
          <div class="w-100 d-flex justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-1"
              :disabled="invalid"
              @click="onSaveAbsent()"
            >
              <span class="text-right">
                <feather-icon icon="CheckIcon" /> Lưu
              </span>
            </b-button>

            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-secondary"
              @click="$bvModal.hide('absentModal')"
            >
              <span class="text-right">
                <feather-icon icon="XIcon" /> Hủy
              </span>
            </b-button>
          </div>
        </template>
      </b-modal>
    </validation-observer>
    <vue-html2pdf
      ref="html2Pdf"
      :show-layout="controlValue.showLayout"
      :float-layout="controlValue.floatLayout"
      :enable-download="controlValue.enableDownload"
      :preview-modal="controlValue.previewModal"
      :filename="controlValue.filename"
      :paginate-elements-by-height="controlValue.paginateElementsByHeight"
      :pdf-quality="controlValue.pdfQuality"
      :pdf-format="controlValue.pdfFormat"
      :pdf-orientation="controlValue.pdfOrientation"
      :pdf-content-width="controlValue.pdfContentWidth"
      :manual-pagination="controlValue.manualPagination"
      :html-to-pdf-options="htmlToPdfOptions"
      @hasDownloaded="hasDownloaded($event)"
    >
      <pdf-content
        slot="pdf-content"
        :content-pdf="contentPdf"
        :list-student-examination-room="this.studentExaminationRooms"
      />
    </vue-html2pdf>
  </div>
</template>

<script>
import {
  BButtonGroup,
  BButton,
  BCard,
  BCol,
  BContainer,
  BFormGroup,
  BOverlay,
  BRow,
  BDropdown,
  BDropdownItem,
  BFormInput,
  BFormInvalidFeedback,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import vSelect from 'vue-select'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import VueHtml2pdf from 'vue-html2pdf'
import PdfContent from '@/views/student-examination-room/PdfContent.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@core/utils/validations/validations'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'
import { getUser } from '@/auth/utils'
import { showErrorToast, showSuccessToast } from '@/utils/notification'

export default {
  name: 'StudentExaminationRoom',
  directives: {
    Ripple,
  },
  components: {
    PdfContent,
    BButton,
    BButtonGroup,
    BDropdown,
    BDropdownItem,
    BFormGroup,
    BCard,
    BCol,
    BContainer,
    BFormInput,
    BOverlay,
    BRow,
    VueGoodTable,
    BFormInvalidFeedback,
    vSelect,
    VueHtml2pdf,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    extData: {
      type: Object,
      default: () => ({
        id: null,
        subject_id: null,
        is_retest: null,
        isSeparateRoom: null,
      }),
    },
  },
  data() {
    return {
      user: getUser(),
      required,
      trainingSystemSelected: undefined,
      coursesSemestersSelected: undefined,
      examinationRoomSubjectsSelected: undefined,
      subjectsSelected: undefined,
      subjectName: undefined,
      roomName: undefined,
      isThiLai: 0,
      isLoading: false,
      room_id_change: undefined,
      isCreateHeader: false,
      selectedRowTable: [],
      deductedValue: 0,
      deductedReason: null,
      studentExaminationRoomId: 0,
      absentForm: { id: null, absentType: null, note: '' },
      filter: {
        examination_room_id: null,
      },
      contentRendered: false,
      generatingPdf: false,
      pdfDownloaded: false,
      controlValue: {
        showLayout: false,
        floatLayout: true,
        enableDownload: true,
        previewModal: true,
        paginateElementsByHeight: 1100,
        manualPagination: false,
        filename: 'Danhsachphach',
        pdfQuality: 2,
        pdfFormat: 'a4',
        pdfOrientation: 'portrait',
        pdfContentWidth: '800px',
      },
      contentPdf: {
        heDaoTao: '',
        lop: '',
        namHoc: '',
        hocKy: '',
        phongThi: '',
        monHoc: '',
        lanThi: 1,
      },
      paginationOptions: {
        enabled: false,
      },
      columns: [
        {
          label: 'STT',
          field: 'stt',
          width: '5%',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Mã sinh viên',
          field: 'code',
          sortable: false,
          width: '10%',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Họ đệm',
          field: 'last_name',
          sortable: false,
          width: '15%',
          thClass: 'text-center',
          tdClass: 'text-right',
        },
        {
          label: 'Tên',
          field: 'name',
          sortable: false,
          width: '15%',
          thClass: 'text-center',
          tdClass: 'text-left',
        },
        {
          label: 'Ngày sinh',
          field: 'birthday',
          sortable: false,
          width: '12%',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Lớp học',
          field: 'class_name',
          width: '23%',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'SBD',
          field: 'bib_number',
          sortable: false,
          width: '10%',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Số phách',
          field: 'header_code',
          width: '10%',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Thao tác',
          field: 'action',
          width: '15%',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
      studentExaminationRoomsByHeaderCode: [],
    }
  },
  computed: {
    ...mapGetters({
      studentExaminationRooms: 'studentExaminationRoom/studentExaminationRooms',
      examinationRoomSubjects: 'studentExaminationRoom/examinationRoomSubjects',
      coursesSemesters: 'studentExaminationRoom/coursesSemesters',
      allTrainingSystem: 'studentExaminationRoom/allTrainingSystem',
      subjects: 'studentExaminationRoom/subjects',
      title: 'studentExaminationRoom/title',
      absentTypes: 'studentExaminationRoom/absentTypes',
      deductLevels: 'dropdown/deductLevels',
      dataExportExaminationStudentTnh: 'studentExaminationRoom/dataExportExaminationStudentTnh',
    }),
    htmlToPdfOptions() {
      return {
        margin: 0,
        filename: 'Danhsachphach.pdf',
        image: {
          type: 'jpeg',
          quality: 0.98,
        },
        enableLinks: true,
        html2canvas: {
          scale: this.controlValue.pdfQuality,
          useCORS: true,
        },
        jsPDF: {
          unit: 'in',
          format: this.controlValue.pdfFormat,
          orientation: this.controlValue.pdfOrientation,
        },
      }
    },
    coursesSemestersOptions() {
      return this.coursesSemesters.map(item => ({ value: item.id, label: item.name }))
    },
    examinationRoomSubjectsOptions() {
      return this.examinationRoomSubjects.map(item => ({ value: item.id, label: item.name }))
    },
    trainingSystemsOptions() {
      return this.allTrainingSystem.map(item => ({ value: item.id, label: item.name }))
    },
    subjectsOptions() {
      return this.subjects.map(item => ({ value: item.code, label: item.name }))
    },
    roomOptions() {
      return this.examinationRoomSubjects.map(item => ({ value: item.id, label: `${item.name}` }))
    },
    headerCodeCreatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.HEADER_CODE_EXAM)
    },
    canRemixHeaderCode() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.REMIX_EXAMINATION_HEADER)
    },
    changeExaminationRoomUpdatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.STUDENT_EXAMINATION_ROOM)
    },
    supervisorExaminationRoomUpdatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.SUPERVISOR_EXAMINATION_ROOM)
    },
    changeExaminationRoomPrintable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.PRINT, ResourceCode.STUDENT_EXAMINATION_ROOM)
    },
    selectedSubjectId() {
      return this.subjects.find(e => e.code === this.subjectsSelected).id || 0
    },
    isSeparateRoom() {
      return (this.subjectsSelected.includes('_THCLASS_')) ? 1 : 0
    },
    reportExaminationStudentTnh() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.READ, ResourceCode.TNH_REPORT_STUDENT_EXAMINATION_ROOM)
    },
  },
  async created() {
    this.filter.examination_room_id = this.extData ? this.extData.id : null
    this.isLoading = true
    try {
      if (this.filter.examination_room_id) {
        await Promise.all([
          this.getTitleValue(),
          this.getStudentExaminationRooms(this.filter)])
        this.checkIsCreateHeader()
      } else {
        await this.begin()
      }
    } catch (e) {
      showErrorToast(this, e)
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    ...mapActions({
      begin: 'studentExaminationRoom/begin',
      getStudentExaminationRooms: 'studentExaminationRoom/getStudentExaminationRooms',
      getCoursesSemesters: 'studentExaminationRoom/getCoursesSemesters',
      getSubjects: 'studentExaminationRoom/getSubjects',
      getExaminationRoomSubjects: 'studentExaminationRoom/getExaminationRoomSubjects',
      changeExaminationRooms: 'studentExaminationRoom/changeExaminationRooms',
      getTitle: 'studentExaminationRoom/getTitle',
      createHeaderStudentExaminationRoom: 'examinationRoom/createHeaderStudentExaminationRoom',
      createHeaderStudentExaminationRoomAgain: 'examinationRoom/createHeaderStudentExaminationRoomAgain',
      banStudent: 'studentExaminationRoom/banStudentExaminationRooms',
      deductedStudent: 'studentExaminationRoom/deductedStudentExaminationRooms',
      saveAbsent: 'studentExaminationRoom/saveAbsent',
      exportPdfScoreHeaderCode: 'studentExaminationRoom/exportPdfScoreHeaderCode',
      getDeductLevels: 'dropdown/getDeductLevels',
      exportPdfDanhSachSinhVien: 'studentExaminationRoom/exportPdfDanhSachSinhVien',
      downloadExportExaminationStudentTnh: 'studentExaminationRoom/downloadExportExaminationStudentTnh',
    }),
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },

    onChangeTrainingSystem() {
      if (this.trainingSystemSelected == null) {
        this.reset()
        this.$store.commit('studentExaminationRoom/SET_COURSESSEMESTERS', { data: [] })
        this.$store.commit('studentExaminationRoom/SET_EXAMINATIONROOMSUBJECTS', { data: [] })
        this.$store.commit('studentExaminationRoom/SET_SUBJECT', { data: [] })
        this.coursesSemestersSelected = null
        this.examinationRoomSubjectsSelected = null
        this.subjectsSelected = null
      } else {
        this.getCoursesSemesters({
          organizationId: getUser().orgId,
          training_system_id: this.trainingSystemSelected,
        })
      }
    },

    onChangeCoursesSemester() {
      if (this.coursesSemestersSelected == null) {
        this.reset()
        this.$store.commit('studentExaminationRoom/SET_SUBJECT', { data: [] })
        this.$store.commit('studentExaminationRoom/SET_EXAMINATIONROOMSUBJECTS', { data: [] })
        this.examinationRoomSubjectsSelected = null
        this.subjectsSelected = null
      } else {
        this.getSubjects({
          organizationId: getUser().orgId,
          courses_semester_id: this.coursesSemestersSelected,
          hasExam: 1,
        })
      }
    },

    async onChangeSubjects() {
      this.examinationRoomSubjectsSelected = null
      this.reset()
      if (this.subjectsSelected == null) {
        this.$store.commit('studentExaminationRoom/SET_EXAMINATIONROOMSUBJECTS', { data: [] })
      } else {
        this.isLoading = true
        try {
          await this.getExaminationRoomSubjects({
            organizationId: getUser().orgId,
            courses_semester_id: this.coursesSemestersSelected,
            subject_id: this.selectedSubjectId,
            is_separate: this.isSeparateRoom,
          })
        } catch (e) {
          showErrorToast(this, e)
        } finally {
          this.isLoading = false
        }
      }
    },

    async onChangeExaminationRoomSubjects() {
      this.reset()
      if (this.examinationRoomSubjectsSelected) {
        const item = this.examinationRoomSubjects.find(x => x.id === this.examinationRoomSubjectsSelected)
        this.subjectName = item.subject_name
        this.roomName = item.room_name
        this.filter.examination_room_id = this.examinationRoomSubjectsSelected
        this.isLoading = true
        try {
          await this.getTitleValue()
        } catch (e) {
          showErrorToast(this, e)
        } finally {
          this.isLoading = false
        }
      }
    },

    reset() {
      this.subjectName = null
      this.roomName = null
      this.filter.examination_room_id = 0
      this.$store.commit('studentExaminationRoom/SET_STUDENTEXAMINATIONROOMS', { data: [] })
    },

    async onCreateHeaderCode() {
      this.$swal({
        title: 'Bạn chắc chắn muốn tạo phách cho TẤT CẢ phòng thi của môn học này?',
        text: 'Hãy kiểm tra TẤT CẢ phòng đã kết thúc thi!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await this.createHeaderStudentExaminationRoom({
              courses_semester_id: this.title[0].course_semester_id,
              subject_id: this.extData ? this.extData.subject_id : this.selectedSubjectId,
              is_retest: this.extData.is_retest ? this.extData.is_retest : this.isThiLai,
              is_separate: this.extData.isSeparateRoom,
              examinationSchedulerId: this.extData?.examinationSchedulerId || null,
            })
            // @TODO: hien thong bao tao phach thanh cong
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                showSuccessToast(this, message)
                await this.onSelectStudentExaminationRoom()
              } else {
                showErrorToast(this, message)
              }
            }
            this.isCreateHeader = hasPermissionForResource(PermissionCode.CREATE, ResourceCode.REMIX_EXAMINATION_HEADER)
          } catch (e) {
            showErrorToast(this, e)
          } finally {
            this.isLoading = false
          }
        }
      })
    },

    async onCreateHeaderCodeAgain() {
      this.$swal({
        title: 'Bạn chắc chắn muốn tạo lại phách cho TẤT CẢ phòng thi của môn học này?',
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await this.createHeaderStudentExaminationRoomAgain({
              courses_semester_id: this.title[0].course_semester_id,
              subject_id: this.title[0].subject_id,
              is_retest: this.extData.is_retest,
              is_separate: this.extData.isSeparateRoom,
              examinationSchedulerId: this.extData?.examinationSchedulerId || null,
            })
            // @TODO: hien thong bao tao lai phach thanh cong
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                showSuccessToast(this, message)
                await this.onSelectStudentExaminationRoom()
              } else {
                showErrorToast(this, message)
              }
            }
          } catch (e) {
            showErrorToast(this, e)
          } finally {
            this.isLoading = false
          }
        }
      })
    },

    async getTitleValue() {
      await this.getTitle(this.filter)
      this.contentPdf.heDaoTao = this.title[0]?.heDaoTao
      this.contentPdf.phongThi = this.title[0]?.phongThi
      this.contentPdf.hocKy = this.title[0]?.hocKy
      this.contentPdf.monHoc = this.title[0]?.monHoc
      this.contentPdf.namHoc = this.title[0]?.namHoc
    },

    checkIsCreateHeader() {
      if (this.studentExaminationRooms.length > 0) {
        const student = this.studentExaminationRooms[0]
        if (student?.header_code && student?.header_code.trim().length > 0) {
          this.isCreateHeader = true
          return this.isCreateHeader
        }
      }
      return false
    },

    async onSelectStudentExaminationRoom() {
      this.isLoading = true
      try {
        await this.getStudentExaminationRooms(this.filter)
        this.checkIsCreateHeader()
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    async exportExaminationStudentTnh() {
      await this.downloadExportExaminationStudentTnh({
        examination_room_id: this.filter.examination_room_id,
      })
      const a = document.createElement('a')
      document.body.appendChild(a)
      const blob = new Blob([this.dataExportExaminationStudentTnh.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = 'danh_sach_sinh_vien_phong_thi'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    async onDeducted(item) {
      this.isLoading = true
      try {
        await this.getDeductLevels({ organizationId: this.user.orgId })
        this.studentExaminationRoomId = item.students_examination_room_id
        this.deductedReason = item.note
        this.deductedValue = item.percent_deducted
        this.$refs.deductedModal.show()
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },

    onMarkAbsent(item) {
      this.absentForm.id = item.students_examination_room_id
      this.absentForm.absentType = item.absentType
      this.absentForm.note = item.note ? item.note : ''
      this.$refs.absentModal.show()
    },

    onBan(item) {
      this.$swal({
        title: `Bạn chắc chắn muốn hủy bài thi sinh viên <span class="text-danger">${item.last_name} ${item.name}</span>?`,
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await this.banStudent({ student_examination_room_id: item.students_examination_room_id })
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                showSuccessToast(this, message)
                await this.getStudentExaminationRooms(this.filter)
              } else {
                showErrorToast(this, message)
              }
            }
          } catch (e) {
            showErrorToast(this, e)
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },

    exportExcel() {
      this.isLoading = true
      if (this.studentExaminationRooms.length > 0) {
        try {
          this.studentExaminationRoomsByHeaderCode = [...this.studentExaminationRooms].sort((a, b) => a.header_code - b.header_code)
          const tHeader = ['Mã sinh viên', 'Họ đệm', 'Tên', 'Ngày sinh', 'Lớp học', 'SBD', 'Số phách']
          const filterVal = ['code', 'last_name', 'name', 'birthday', 'class_name', 'bib_number', 'header_code']
          const dataJson = this.formatJson(filterVal, this.studentExaminationRoomsByHeaderCode)
          import('@/utils/Export2Excel').then(excel => {
            excel.export_json_to_excel({
              header: tHeader,
              data: dataJson,
              filename: 'Danhsachphach',
              autoWidth: true,
              bookType: 'xlsx',
            })
          })
        } catch (e) {
          showErrorToast(this, e)
        } finally {
          this.isLoading = false
        }
      } else {
        showErrorToast(this, 'Chưa thực hiện lấy danh sách phách')
        this.isLoading = false
      }
    },

    async downloadPdf() {
      this.isLoading = true
      if (this.studentExaminationRooms.length > 0) {
        try {
          const data = await this.exportPdfDanhSachSinhVien({
            examination_room_id: this.filter.examination_room_id,
          })
          if (data) {
            const url = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }))
            window.open(url, '_blank')
          } else {
            showErrorToast(this, 'File không có dữ liệu')
          }
        } catch (e) {
          showErrorToast(this, e)
        } finally {
          this.isLoading = false
        }
      } else {
        showErrorToast(this, 'Chưa thực hiện lấy danh sách phách')
        this.isLoading = false
      }
    },

    compare(propName) {
      return function (a, b) {
        if (a[propName] < b[propName]) return -1
        if (a[propName] > b[propName]) return 1
        return 0
      }
    },

    async downloadPdf_DiemPhach() {
      this.isLoading = true
      try {
        const data = await this.exportPdfScoreHeaderCode({
          examinationRoomId: this.filter.examination_room_id,
          score: 0, // Không hiện điểm
        })
        if (data) {
          const url = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }))
          window.open(url, '_blank')
        } else {
          showErrorToast(this, 'File không có dữ liệu')
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    hasDownloaded(blobPdf) {
      this.pdfDownloaded = true
    },
    selectionChanged(event) {
      this.selectedRowTable = event.selectedRows
    },

    async onChangeExaminationRom() {
      if (this.selectedRowTable.length > 0) {
        await this.getExaminationRoomSubjects({
          courses_semester_id: this.title[0].course_semester_id,
          subject_id: this.title[0].subject_id,
        })
        this.$refs.examinationRoomModal.show()
      }
    },

    async onSave() {
      try {
        if (this.room_id_change > 0) {
          await this.changeExaminationRooms({ examination_room_id: this.room_id_change.toString(), list_student_id: this.selectedRowTable.map(item => (item.students_examination_room_id)).join(',') })
          showSuccessToast(this, 'Chuyển danh sách phòng thi thành công')
          await this.getStudentExaminationRooms(this.filter)
        } else {
          showErrorToast(this, 'Chưa chọn phòng thi để chuyển!')
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.$bvModal.hide('examinationRoomModal')
      }
    },
    onchangeDeductLevel() {
      this.deductedReason = ''
    },
    async onSaveDeducted() {
      const valid = this.$refs.deductedFormRef.validate()
      if (valid) {
        try {
          const deductId = this.deductLevels.find(e => e.value === this.deductedValue).id
          await this.deductedStudent({
            deductId,
            student_examination_room_id: this.studentExaminationRoomId,
            deducted_value: this.deductedValue,
            deducted_reason: this.deductedReason,
          })
          showSuccessToast(this, 'Thực hiện trừ điểm thành công!')
          await this.getStudentExaminationRooms(this.filter)
          this.$bvModal.hide('deductedModal')
        } catch (e) {
          showErrorToast(this, e)
        }
      }
    },

    async onSaveAbsent() {
      try {
        const response = await this.saveAbsent(this.absentForm)
        if (response) {
          const {
            isSuccessful,
            message,
          } = response
          if (isSuccessful) {
            showSuccessToast(this, message)
            this.$bvModal.hide('absentModal')
            await this.getStudentExaminationRooms(this.filter)
          } else {
            showErrorToast(this, message)
          }
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.absentForm = { id: null, absentType: null, note: '' }
        this.isLoading = false
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.reset()
    next()
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
